// import UserCardsContainer from "../../../../Component/Application/Users/UserCards/UserCards"
import UserCardsContainer from "../../../../Component/Application/Users/List"

const UserCards = ({ user_type_id }: { user_type_id: string }) => {
  return (
    <div className='page-body'>
      <UserCardsContainer user_type_id={user_type_id}/>
    </div>
  )
}

export default UserCards